import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-image-side',
  imports: [CommonModule],
  templateUrl: './image-side.component.html',
  styleUrl: './image-side.component.scss'
})
export class ImageSideComponent {
@Input() customClass:string="mt-4";
@Input() screenType:string="";
}
